import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

// modules (angular)
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {MatTableModule as MatTableModule} from '@angular/material/table';

// modules

// components
import { LayoutComponent } from './components/layout/layout.component';

// pages
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { QuotationRoutingModule } from './quotation-cart-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import { QuotationRequestsComponent } from './pages/quotation-requests/quotation-requests.component';
import { ActiveQuotationsComponent } from './pages/active-quotations/active-quotations.component';
import { VendorQuotationComponent } from './pages/quotation-requests/quotation-vendor/quotation-vendor.component';
import { QuotationHistoryComponent } from './pages/quotation-history/quotation-history.component';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
    imports: [
        // modules (angular)
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        FlexLayoutModule,
        MatTableModule,
        // modules
        QuotationRoutingModule,
        SharedModule,
        MatDividerModule,
        // components
        LayoutComponent,
        // pages
        QuotationRequestsComponent,
        ActiveQuotationsComponent,
        VendorQuotationComponent,
        QuotationHistoryComponent,
    ],
    exports: [QuotationHistoryComponent, ActiveQuotationsComponent, QuotationRequestsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class QuotationModule { }
